import {
  ORDER_STATUSES,
  TITLES,
} from '@components/CRM/Orders/OrderStatus/constants';

import { B2BOrderStatus, B2BTouristDocumentType } from './types';

export type StatusFilter = B2BOrderStatus | 'all';

export const DOCUMENT_TYPE_OPTIONS: Array<{
  title: string;
  value: B2BTouristDocumentType;
}> = [
  { title: 'Загранпаспорт', value: 'international_passport' },
  { title: 'Внутренний паспорт', value: 'internal_passport' },
  { title: 'Свидетельство о рождении', value: 'birth_certificate' },
];

export const STATUS_OPTIONS: Array<{
  title: string;
  value: StatusFilter;
}> = [
  { title: 'Все статусы', value: 'all' },
  { title: TITLES[ORDER_STATUSES.CREATED], value: ORDER_STATUSES.CREATED },
  { title: TITLES[ORDER_STATUSES.APPROVED], value: ORDER_STATUSES.APPROVED },
  {
    title: TITLES[ORDER_STATUSES.COOLING],
    value: ORDER_STATUSES.COOLING,
  },
  { title: TITLES[ORDER_STATUSES.PAID], value: ORDER_STATUSES.PAID },
  { title: TITLES[ORDER_STATUSES.BOOKED], value: ORDER_STATUSES.BOOKED },
  {
    title: TITLES[ORDER_STATUSES.NOT_CONFIRMED],
    value: ORDER_STATUSES.NOT_CONFIRMED,
  },
  { title: TITLES[ORDER_STATUSES.CONFIRMED], value: ORDER_STATUSES.CONFIRMED },
  { title: TITLES[ORDER_STATUSES.DEPOSIT], value: ORDER_STATUSES.DEPOSIT },
  {
    title: TITLES[ORDER_STATUSES.DOCUMENTS_SENT],
    value: ORDER_STATUSES.DOCUMENTS_SENT,
  },
  {
    title: TITLES[ORDER_STATUSES.FLIGHT_CONFIRMED],
    value: ORDER_STATUSES.FLIGHT_CONFIRMED,
  },
  {
    title: TITLES[ORDER_STATUSES.HOTEL_CONFIRMED],
    value: ORDER_STATUSES.HOTEL_CONFIRMED,
  },
  { title: TITLES[ORDER_STATUSES.ON_TRIP], value: ORDER_STATUSES.ON_TRIP },
  { title: TITLES[ORDER_STATUSES.GOT_BACK], value: ORDER_STATUSES.GOT_BACK },
  {
    title: TITLES[ORDER_STATUSES.SURVEY_COMPLETED],
    value: ORDER_STATUSES.SURVEY_COMPLETED,
  },
  { title: TITLES[ORDER_STATUSES.CANCELED], value: ORDER_STATUSES.CANCELED },
  { title: TITLES[ORDER_STATUSES.ANNULLED], value: ORDER_STATUSES.ANNULLED },
];
